import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

//components
import Field from '../../Common/Field/Field'
import Button from '../../Buttons/Button'

//services 
import { DevelopmentServices } from '../../../services'

export default class YarnDyed extends Component {
    state = {
        yarnDyed: {}
    }

    componentWillMount() {
        const { actionedByOption, fabricInfo, yarnDyed, noOfColsWeftOptions } = this.props
        this.setState({
            actionedByOption, fabricInfo, yarnDyed, noOfColsWeftOptions
        })
    }

    componentDidMount() {
        if (this.props.scroll) {
            var yarnDyedEle = document.getElementById('yarnDyedId')
            yarnDyedEle.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        }
    }

    componentWillReceiveProps(nextProps) {
        const { actionedByOption, fabricInfo, yarnDyed, noOfColsWeftOptions } = nextProps
        this.setState({
            actionedByOption, fabricInfo, yarnDyed, noOfColsWeftOptions
        })
    }

    updateValue = (name, value) => {
        this.props.getYarnDyed('yarnDyed', name, value)
    }

    createYarnDyed = (e) => {
        e.preventDefault()
        let yarnDyed = { ...this.state.yarnDyed }
        let _id = this.props._id
        yarnDyed.actionedBy = null
        let toggle = { ...this.props.toggle }
        DevelopmentServices.createYarnDyed(yarnDyed, toggle, _id).then(response => {
            if (response.status === 200) {

                this.props.getalertMessage('success', ' Yarndyed created ')
            }

            response.status === 401 && this.props.unauthorisedFunc()
        })
    }

    resetYarnDyedForm = (e) => {

    }


    render() {

        const { fabricInfo, yarnDyed, noOfColsWeftOptions } = this.state

        const { disabled, washoptions } = this.props


        return (
            <div className="col-md-12 px-5 " id="yarnDyedId" >
                <h6 className="text-green font-lg font-weight-bold">Yarn Dyed</h6>
                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='actionedBy'
                        value={fabricInfo && fabricInfo.YARNDYED && fabricInfo.YARNDYED.ASSIGNEDTO && fabricInfo.YARNDYED.ASSIGNEDTO.length > 0 && fabricInfo.YARNDYED.ASSIGNEDTO[0].value}
                        options={fabricInfo && fabricInfo.YARNDYED && fabricInfo.YARNDYED.ASSIGNEDTO ? fabricInfo.YARNDYED.ASSIGNEDTO : []}
                        label='Assigned To'
                        onChange={this.updateValue}
                        disabled={true}
                    />
                </div>
                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='typeOfLoom'
                        value={yarnDyed.typeOfLoom}
                        options={fabricInfo && fabricInfo.YARNDYED ? fabricInfo.YARNDYED.TYPEOFLOOM : []}
                        label='Type of loom'
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>
                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='dyeStuff'
                        value={yarnDyed.dyeStuff}
                        options={fabricInfo.DYESTUFF}
                        label='Dye stuff'
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>

                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='noOfColsWeft'
                        value={yarnDyed.noOfColsWeft}
                        options={fabricInfo.NOOFCOLSONWEFT}
                        label='No of cols on weft'
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>
                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='number'
                        inputName='designRepeatSize'
                        value={yarnDyed.designRepeatSize}
                        label='Design Repeat Size'
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>
                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='weave'
                        value={yarnDyed.weave}
                        options={fabricInfo && fabricInfo.YARNDYED ? fabricInfo.YARNDYED.WEAVE : []}
                        label='Weave'
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>

                <div className="col-md-2 step-one">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='finish'
                        value={yarnDyed.finish}
                        options={fabricInfo.FINISH}
                        label='Finish'
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>

                <div className="col-md-2 step-one pr-0">
                    <Field
                        isFormGroup={true}
                        inputType='select'
                        inputName='wash'
                        label='Wash'
                        value={yarnDyed.wash}
                        options={fabricInfo.WASH}
                        onChange={this.updateValue}
                        disabled={disabled}
                    />
                </div>

                <div className="col-md-12 profile-btn text-center">
                    {this.state.action != 'view' && <Button
                        buttonName='Save'
                        onClick={this.createYarnDyed}
                    />}
                    <Button
                        buttonName='Cancel'
                        buttonType='cancel'
                        history={this.props.history}
                    />
                </div>
            </div>
        )
    }
}

YarnDyed.propTypes = {

};

YarnDyed.defaultProps = {

}


// WEBPACK FOOTER //
// ./src/components/Fabric/YarnDyed/YarnDyed.js